/* JUANCHO interactions: scroll reveals, delayed hero CTAs, lightbox, hero video pause. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var targets = document.querySelectorAll('.j-reveal, .j-mask');
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initHero() {
    document.querySelectorAll('[data-j-hero]').forEach(function (hero) {
      var ctas = hero.querySelector('.j-hero__ctas');
      if (ctas) {
        if (reduced) { ctas.classList.add('is-in'); }
        else {
          var shown = false;
          var show = function () { if (!shown) { shown = true; ctas.classList.add('is-in'); } };
          setTimeout(show, 3200);
          window.addEventListener('scroll', show, { once: true, passive: true });
        }
      }
      var video = hero.querySelector('video');
      var btn = hero.querySelector('.j-hero__pause');
      if (video && btn) {
        if (reduced) { video.pause(); btn.textContent = '\u25B6'; }
        btn.addEventListener('click', function () {
          if (video.paused) { video.play(); btn.textContent = '\u2016'; btn.setAttribute('aria-label', 'Pause background video'); }
          else { video.pause(); btn.textContent = '\u25B6'; btn.setAttribute('aria-label', 'Play background video'); }
        });
      }
    });
  }

  function initLightbox() {
    var galleries = document.querySelectorAll('[data-j-gallery]');
    if (!galleries.length) return;
    var box = document.createElement('div');
    box.className = 'j-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML = '<button class="j-lightbox__close" aria-label="Close">\u2715</button>' +
      '<button class="j-lightbox__prev" aria-label="Previous image">\u2190</button>' +
      '<img alt="">' +
      '<button class="j-lightbox__next" aria-label="Next image">\u2192</button>';
    document.body.appendChild(box);
    var img = box.querySelector('img');
    var items = [], index = 0, lastFocus = null;

    function render() {
      var it = items[index];
      img.src = it.src;
      img.alt = it.alt || '';
    }
    function open(list, i, trigger) {
      items = list; index = i; lastFocus = trigger;
      render();
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      box.querySelector('.j-lightbox__close').focus();
    }
    function close() {
      box.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    function step(d) { index = (index + d + items.length) % items.length; render(); }

    galleries.forEach(function (g) {
      var triggers = Array.prototype.slice.call(g.querySelectorAll('[data-j-full]'));
      var list = triggers.map(function (t) {
        var im = t.querySelector('img');
        return { src: t.getAttribute('data-j-full'), alt: im ? im.alt : '' };
      });
      triggers.forEach(function (t, i) {
        t.addEventListener('click', function () { open(list, i, t); });
      });
    });

    box.querySelector('.j-lightbox__close').addEventListener('click', close);
    box.querySelector('.j-lightbox__prev').addEventListener('click', function () { step(-1); });
    box.querySelector('.j-lightbox__next').addEventListener('click', function () { step(1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
  }

  function boot() { initReveals(); initHero(); initLightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
